import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

interface TableScrollWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const TableScrollWarningModal = ({ isOpen, onClose, onConfirm }: TableScrollWarningModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size='md'>
      <ModalHeader toggle={onClose}>Warning</ModalHeader>
      <ModalBody>
        This table has hidden rows/columns due to scrolling. Data that is not visible on screen will not appear in the
        exported PDF.
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button color='primary' onClick={onConfirm}>
          Export Anyway
        </Button>
      </ModalFooter>
    </Modal>
  );
};
